import { ValueGetterFunc } from "ag-grid-community";
import { OffHoursSchedule } from "@/services/cloudchipr.api";
import { offHoursAllActions } from "@/components/pages/automations/off-hours/utils/constants/common";

export const offHoursActionValueGetter: ValueGetterFunc<OffHoursSchedule> = ({
  data,
}) => {
  if (!data) {
    return "-";
  }

  const action = data.action && offHoursAllActions[data.action];

  return action ? action : "-";
};
